module.exports = __webpack_public_path__ + "static/img/productbg.9157e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/productbg.jpg
// module id = RKT0
// module chunks = 1